export default __webpack_public_path__ + "static/wwu-2-d824d1b871318b432ce22c9057d9bd19.png";